export default "__VITE_ASSET__so3$Dz6h__"